/**
 * Production handlers: log uncaught JS errors to the local issue report store.
 */
import { reportIssue } from './issueReport';

type ReactNativeErrorUtils = {
  getGlobalHandler?: () => ((error: Error, isFatal?: boolean) => void) | undefined;
  setGlobalHandler?: (handler: (error: Error, isFatal?: boolean) => void) => void;
};

function getReactNativeErrorUtils(): ReactNativeErrorUtils | undefined {
  return (globalThis as typeof globalThis & { ErrorUtils?: ReactNativeErrorUtils }).ErrorUtils;
}

export function installIssueReportHandlers(): void {
  const error_utils = getReactNativeErrorUtils();
  if (!error_utils?.setGlobalHandler) {
    return;
  }
  const previous = error_utils.getGlobalHandler?.();
  error_utils.setGlobalHandler((error: Error, is_fatal?: boolean) => {
    const stack = error?.stack?.split('\n').slice(0, 12).join('\n') ?? '';
    reportIssue({
      page: 'Global',
      issue: is_fatal ? 'Fatal JavaScript error' : 'Uncaught JavaScript error',
      kind: 'crash',
      error_message: error?.message ?? String(error),
      stack,
    });
    previous?.(error, is_fatal);
  });
}
